import React from "react";
import "./utilities/master.scss";


import AllRoutes from "./routes/routes";

const App = () => {
  return (
    <div className="app-component">
      <AllRoutes />
    </div>
  );
};

export default App;
